import React from 'react';
import '../check-box/MyCheckBox.css';

interface CheckBoxProps {
  checked: boolean | undefined;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  ariaLabel: string;
  name: string;
}

const MyCheckBox: React.FC<CheckBoxProps> = ({ checked, onChange, ariaLabel, name }) => {
  return (
    <div>
      <label className="container">
        <input
          checked={checked}
          onChange={onChange}
          type="checkbox"
          aria-label={ariaLabel}
          name={name}
        />
        <div className="checkmark"></div>
      </label>
    </div>
  );
};

export default MyCheckBox;
